import normalize_jss from 'normalize-jss';
import { createUseStyles } from 'react-jss';

import { baseFont, linkColor } from '../../../theme';

export const gradient = 'linear-gradient(292.42deg, #004B70 0%, #009ACE 100%)';

export default createUseStyles(
  {
    ...normalize_jss,

    '@global html': {
      // TODO theme
      background: gradient,
      minHeight: '100vh',
    },

    '@global body': {
      position: 'relative',
      background: gradient,
      minHeight: '100vh',
    },

    root: {
      all: 'initial',
      ...baseFont,

      '& button, & input': {
        fontFamily: 'inherit',
      },

      '& a': {
        color: linkColor,
        textDecoration: 'none',
      },

      '& a:hover': {
        textDecoration: 'underline',
      },
    },
  },
  {
    name: 'CssBaseline-loginPages',
  },
);
